// extracted by mini-css-extract-plugin
module.exports = {"CustomerSaying":"CustomerSaying_CustomerSaying__ovmQo"};